__turbopack_context__.v({
  "newsignup": "newpass-module__Zk63RW__newsignup",
  "newsignuphead": "newpass-module__Zk63RW__newsignuphead",
  "title": "newpass-module__Zk63RW__title",
});
